import React from 'react';

const ButtonScrollToForm = () => {
  const handleClick = () => {
    const formElement = document.getElementById('artwork-submission-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const [showButton, setShowButton] = React.useState(false);

  const handleScroll = () => {
    // also check in the form "artwork-submission-form" is in view, if so hide the button
    const formElement = document.getElementById('artwork-submission-form');
    if (formElement) {
      const rect = formElement.getBoundingClientRect();

      if (rect.top < 400) {
        setShowButton(false);
        return;
      }
    }

    if (window.scrollY > 100) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <button
      onClick={handleClick}
      style={{
        opacity: showButton ? 1 : 0,
        position: 'fixed',
        top: '20px',
        right: '20px',
        transition: 'opacity 0.3s',
        zIndex: 300,
        borderRadius: '25px',
        background: '#0092D4',
        color: '#fff',
        padding: '10px 25px',
        border: 'none',
      }}
    >
      Submit your Artwork
    </button>
  );
};

export default ButtonScrollToForm;
